import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import {
  LuggageCardRow, LuggageCardDataType
} from '@design-system/components/molecules/luggage-card/entities/luggage-card.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { DividerDsComponent } from '@design-system/components/atoms/divider/divider.component';

@Component({
  selector: 'app-ds-luggage-card',
  templateUrl: './luggage-card.component.html',
  styleUrls: ['./luggage-card.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    IconDsComponent,
    TypographyDsComponent,
    DividerDsComponent,
  ]
})
export class LuggageCardDsComponent {

  @Input() title: string;
  @Input() rows: LuggageCardRow[];

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  constructor() { }

  public getIcon(row: LuggageCardRow): Icon {
    switch (row?.Type) {
      case LuggageCardDataType.Backpack:
        return Icon.Backpack;
      case LuggageCardDataType.HandLuggage:
        return Icon.HandLuggage;
      default:
        return Icon.Luggage;
    }
  }

  public getIconColor(row: LuggageCardRow): IconFillColor {
    return !row?.IsDisabled ? IconFillColor.Highlight : IconFillColor.Secondary;
  }

  public getTypographyColor(row: LuggageCardRow): TypographyColor {
    return !row?.IsDisabled ? TypographyColor.Highlight : TypographyColor.Secondary;
  }

}
